<app-table-wrap fieldsStr="name,date,title,sign">
	@for (row of signDocument; track row) {
		@if (row.isNewDate) {
			<tr>
				<td
					colspan="99999"
					style="font-size: 18px"
				>
					{{ row.date | dateFormat }}
				</td>
			</tr>
		}
		<tr>
			@if (row.patient_id) {
				<td class="link-patient">
					<app-patient-modal [id]="row.patient_id">
						{{ row.patient_name }}
					</app-patient-modal>
				</td>
			} @else {
				<td>
					{{ row.payor_name || row.user_name }}
				</td>
			}
			<td>
				{{ row.date | dateFormat }}
			</td>
			<td>{{ row.title }}</td>
			<td>
				<button
					titleLang="sign"
					tabindex="-1"
					class="btn btn-primary"
					(click)="editDocument(row)"
					postIcon="plus"
				>
					{{ "sign" | langVal }}
				</button>
			</td>
		</tr>
	}
</app-table-wrap>
@switch (modalProps?.name) {
	@case ("preview-finresource") {
		<app-preview-finresource
			(onClose)="modalProps = null; onClose.emit($event)"
			doctype="document"
			[headtureRow]="modalProps.headtureRow"
			[finresourceObj]="modalProps.finresourceObj"
		/>
	}
	@case ("add-document") {
		<app-modal-wrap
			(onClose)="modalProps = null; onClose.emit($event)"
			title="letter"
			modalWrapperClass="modal-800"
		>
			<app-add-document
				(onClose)="modalProps = null; onClose.emit($event)"
				[documentObj]="modalProps.row"
				[patient_id]="modalProps.row.patient_id"
				[payor_id]="modalProps.row.payor_id"
				[user_id]="modalProps.row.user_id"
				[initRunValidation]="true"
			/>
		</app-modal-wrap>
	}
}
@if (isDefaultSigOpen) {
	<app-require-default-signature
		(onDone)="isDefaultSigOpen = false; $event ? init() : onClose.emit()"
	/>
}
